export function encodeRouteToken(value: string): string {
  return encodeURIComponent(value).replaceAll('%', '~')
}

export function decodeRouteToken(value: string | undefined): string {
  if (!value) return ''
  try {
    return decodeURIComponent(value.replaceAll('~', '%'))
  } catch {
    return value
  }
}

export function serverRoot(origin: string): string {
  return `/servers/${encodeRouteToken(new URL(origin).origin)}`
}

export function agentPath(origin: string, name: string): string {
  return `${serverRoot(origin)}/agents/${encodeRouteToken(name)}`
}

export function taskPath(origin: string, namespace: string, taskId: string): string {
  return `${serverRoot(origin)}/tasks/${encodeRouteToken(namespace)}/${encodeRouteToken(taskId)}`
}
